var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vat-preview-table-wrapper"},[_c('EInvoiceVatTables',{attrs:{"items":_vm.items,"summary":_vm.summary,"preview-mode":"","show-product-image":"","goods-table-max-height":280,"emphasize-summary-total":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }